import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "d-flex align-items-center" }

import {computed, onMounted, onUnmounted, ref} from 'vue';
import {OperatorsStore} from "~/chat/ts/store/Operators";
import {IOperator, IOperatorGroup} from "~/chat/ts/data/IOperator";
import Group from "~/chat/vue/widget/operators/select/Group.vue";
import ChatSelectableItem from "~/chat/vue/misc/ChatSelectableItem.vue";
import Avatars from "~/chat/vue/widget/operators/select/Avatars.vue";
import {ChatEventManagerInstance} from "~/chat/ts/ChatEventManager";
import ChatHistoryTitle from "~/chat/vue/widget/tabs/chat/ChatHistoryTitle.vue";
import {CHAT_EVENT_OPERATOR_SELECTED_MANUALY} from "~/chat/ts/Constants";
import {__} from "~/ts/library/Translate";



const __default__ = {
    name: "OperatorsSelect"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

let selected = ref(false);

onMounted(() => {
    selected.value = false;
});

let groups = computed(() => {
    return OperatorsStore.isSelectGroupAvailable.value ? OperatorsStore.groupsAvailableForSelect.value : [];
});

let operators = computed(() => {
    return OperatorsStore.isSelectOperatorsAvailable.value ? OperatorsStore.visibleOperators.value : [];
});

function setSelected() {
    selected.value = true;
    ChatEventManagerInstance.emit(CHAT_EVENT_OPERATOR_SELECTED_MANUALY);
}

onUnmounted(() => {
    if (!selected.value) {
        setSelected();
    }
});

function selectGroup(group: IOperatorGroup, operator?: IOperator) {
    setSelected();
    OperatorsStore.setSelectedOperator(operator, group);
}

function selectOperator(operator: IOperator) {
    setSelected();
    OperatorsStore.setSelectedOperator(operator);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(groups).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(ChatHistoryTitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(__)('SELECT_OPERATORS_GROUP_FOR_CONVERSTATION')) + ":", 1)
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(groups), (group) => {
            return (_openBlock(), _createBlock(Group, {
              key: group.id,
              group: group,
              onClick: ($event: any) => (selectGroup(group, $event))
            }, null, 8, ["group", "onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_unref(operators).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ChatHistoryTitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(__)("SELECT_OPERATOR_FOR_CONVERSATION")) + ":", 1)
            ]),
            _: 1
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operators), (operator) => {
            return (_openBlock(), _createBlock(ChatSelectableItem, {
              key: operator.id,
              onClick: ($event: any) => (selectOperator(operator))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(Avatars, {
                    class: "mr-3",
                    operators: [operator]
                  }, null, 8, ["operators"]),
                  _createElementVNode("h4", null, _toDisplayString(operator.fio), 1)
                ])
              ]),
              _: 2
            }, 1032, ["onClick"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})